export default __webpack_public_path__ + "static/media/elasticsearch.4e485395.svg";